import script from "./receiveType.vue?vue&type=script&setup=true&lang=js"
export * from "./receiveType.vue?vue&type=script&setup=true&lang=js"

import "./receiveType.vue?vue&type=style&index=0&id=29b497a3&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29b497a3"]])

export default __exports__